<template>
    <SwitchGroup
        as="div"
        class="flex items-center justify-between space-x-3"
    >
        <Switch
            v-model="enabled"
            :disabled="props.disabled"
            :class="[
                enabled ? 'bg-chat-primary' : 'bg-gray-300 dark:bg-neutral-400',
                'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer',
                'chat_transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-chat-primary',
                'dark:focus:ring-offset-neutral-600',
                props.disabled ? 'opacity-50 cursor-not-allowed' : ''
            ]"
        >
            <span
                aria-hidden="true"
                :class="[
                    enabled ? 'translate-x-5' : 'translate-x-0',
                    'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
                    'dark:bg-gray-200'
                ]"
            />
        </Switch>

        <span
            v-if="tLabel !== '' || tDescription !== ''"
            class="flex-grow flex flex-col"
            :class="[
                // Adiciona classes para o estado desabilitado no texto
                 props.disabled ? 'opacity-50' : ''
            ]"
            >
            <SwitchLabel
                as="span"
                class="text-sm font-medium text-gray-900 dark:text-gray-200"
                :class="[
                    // Adiciona cursor not-allowed se o label for clicável (passive=false)
                    // Neste caso é passive=true, então não precisa, mas é bom saber
                    // props.disabled ? 'cursor-not-allowed' : ''
                ]"
                passive
            >
                {{ tLabel }}
            </SwitchLabel>

            <SwitchDescription
                as="span"
                class="text-xs text-gray-500 dark:text-gray-400"
            >
                {{ tDescription }}
            </SwitchDescription>
        </span>
    </SwitchGroup>
</template>

<script setup>
    import { ref, watch, defineEmits, defineProps } from 'vue'
    import { Switch, SwitchDescription, SwitchGroup, SwitchLabel } from '@headlessui/vue'

    const props = defineProps( {
        modelValue: {type: [Boolean, String], default: false},
        tLabel: {type: String, default: '', required: true},
        tDescription: {type: String, default: ''},
        disabled: { type: Boolean, default: false } // Define a nova prop disabled
    })
    const emit = defineEmits(['update:modelValue'])
    // para o sistema nao quebrar, o valor de model value deve ser sempre em string
    // ao validar como boolean quebra em outras partes do sistema
    // é uma bosta ? sim, porem é o que tem pra hoje :(
    const enabled = ref(props.modelValue === 'true')

    // O watch não precisa ser alterado, pois o v-model do Switch
    // não será atualizado se o componente estiver disabled
    watch(() => enabled.value, () => {
        // Verifica se não está desabilitado antes de emitir
        if (!props.disabled) {
             emit('update:modelValue', enabled.value === true ? 'true' : '')
        }
    })

    // Observa mudanças na prop modelValue externa para atualizar o estado interno,
    // respeitando o estado disabled
    watch(() => props.modelValue, (newValue) => {
        const internalValue = newValue === 'true';
        if (enabled.value !== internalValue) {
            enabled.value = internalValue;
        }
    })


</script>
